import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'components/common/controls/Collapsible';
import cx from 'classnames';

const propTypes = {
  children: PropTypes.any,
  title: PropTypes.element,
  hideIcon: PropTypes.bool,
  defaultOpened: PropTypes.bool,
  isOpen: PropTypes.bool,
  mod: PropTypes.string,
  disabled: PropTypes.bool,
  ContentWrapper: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
};

const AccordionTooltip = ({
  children,
  title,
  hideIcon,
  defaultOpened,
  isOpen,
  mod,
  disabled,
  ContentWrapper,
}) => (
  <Collapsible
    type="accordion"
    mod={mod}
    Title={({ onClick, isOpen: isAccordionOpen }) => {
      const titleClasses = cx({
        link: true,
        'link--disabled': disabled,
        'link--icon link--icon-info': !hideIcon,
        'link--icon-open': isAccordionOpen,
        'link--type-btn-link': true,
      });
      return (
        <button type="button" onClick={onClick} className={titleClasses}>
          {title}
        </button>
      );
    }}
    ButtonClose={() => (null)}
    ButtonOpen={() => (null)}
    ButtonCloseMobile={() => (null)}
    defaultOpened={defaultOpened}
    isOpen={isOpen}
    ContentWrapper={ContentWrapper}
  >
    {children}
  </Collapsible>
);

AccordionTooltip.propTypes = propTypes;

export default AccordionTooltip;
